import { render, staticRenderFns } from "./SubjectJiaolianPicker.vue?vue&type=template&id=0164e39b&"
import script from "./SubjectJiaolianPicker.vue?vue&type=script&lang=js&"
export * from "./SubjectJiaolianPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports